export const roles = {
  SITE_ADMIN: 'SiteAdmin',
  ADMIN: 'Admin',
  CUSTOMER_SUPPORT_ADMIN: 'CustomerSupportAdmin',
  CUSTOMER_SUPPORT: 'CustomerSupport',
  ACCOUNTING: 'Accounting',
  MATH_ACCESS: 'MathAccess',
  PRODUCTION: 'Production',
  COMPLIANCE: 'Compliance',
  RELEASE_MANAGER: 'ReleaseManager',
  LEGAL: 'Legal',
};
